// s-menu

$(document).ready(function(){
    $('.s-menu__button').click(function(){
        $('.s-menu').toggleClass('s-menu--open');
        if ($('.s-menu').hasClass('s-menu--open')){
            $('body').css('overflow', 'hidden');
            window.scrollTo(0, 0);

        } else {
            $('body').css('overflow', 'auto');
        }
    });
});

// guestbook

$(document).ready(function(){
    if ($('.ioptions').length > 0){
       
        $('.ioptions').each(function(){
            var ioptions = $(this);
            var addition_a = ioptions.find('.addition a');
            addition_a.click(function(e){
                e.preventDefault();
                ioptions.find('.ioption').each(function(){
                    if (!$(this).hasClass('ioption--show')){
                        $(this).addClass('ioption--show');
                        if (ioptions.find('.ioption--show').length < 4){
                            return false;
                        } else {
                            addition_a.hide();
                        }
                    }
                });
            });
        });

    }
});

// Menu

$(document).ready(function(){

    function check_scroll(){
        if ($(window).scrollTop() > 120){
            $('.s-menu').removeClass('s-menu--top');
            $('.s-banner__block').removeClass('s-banner__block--top');
        } else {
            $('.s-menu').addClass('s-menu--top');
            $('.s-banner__block').addClass('s-banner__block--top');
        }
    }

    if (!$('.s-menu').hasClass('s-menu--additional')){
        check_scroll();
        $(window).scroll(function(){
            check_scroll();
        });
    }
});